import { combineReducers } from 'redux';
import { BillingAction, BillingActionType } from '../../actions/billingActions';
import { PaymentCard, Subscription, BillingInformation } from '../../types/resources';

const OLD_FREE1_TIER_SUBSCRIPTION = {
  state: 'active',
  basePlanId: 'free1',
  basePlan: {
    id: 'free1',
    name: 'Free',
    currency: 'USD',
    level: 0,
    price: 0,
    onDemandRunMinutePrice: 0.05,
    paid: false,
    selectable: true,
    includedActiveAssistants: 1,
    extraActiveAssistantCost: 30,
    extraActiveAssistantsAllowed: false,
    canTriggerProcessesWithEmail: false,
    limits: {
      maxUsers: null,
      maxWorkspaces: 2,
      maxOnDemandRunMinutes: 0,
    },
  },
};

export type BillingState = {
  subscription: Subscription | null;
  card: PaymentCard | null;
  billingInformation: BillingInformation;
};

export const initialState: BillingState = {
  subscription: null,
  card: null,
  billingInformation: {
    name: '',
    email: '',
    address: {},
  } as BillingInformation,
};

const subscription = (state = initialState.subscription, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.GET_CURRENT_SUBSCRIPTION_OK: {
      return action.data || OLD_FREE1_TIER_SUBSCRIPTION; // will return null if on old free1 tier
    }
    case BillingActionType.CHANGE_SUBSCRIPTION_TIER_OK: {
      return action.data || OLD_FREE1_TIER_SUBSCRIPTION; //  will return null if on old free1 tier
    }
    default:
      return state;
  }
};

const card = (state = initialState.card, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.GET_CURRENT_PAYMENT_METHOD_OK: {
      return action.data?.type === 'card' ? action.data?.card : null;
    }
    case BillingActionType.CREATE_PAYMENT_METHOD_OK: {
      return action.data?.type === 'card' ? action.data?.card : null;
    }
    case BillingActionType.DELETE_PAYMENT_METHOD: {
      return null;
    }
    default:
      return state;
  }
};

const billingInformation = (state = initialState.billingInformation, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.GET_CURRENT_PAYMENT_METHOD_OK: {
      return action.data?.type === 'card' ? action.data?.billingInformation : null;
    }
    case BillingActionType.CREATE_PAYMENT_METHOD_OK: {
      return action.data?.type === 'card' ? action.data?.billingInformation : null;
    }
    case BillingActionType.UPDATE_BILLING_INFORMATION_OK: {
      return { ...state, ...action.data };
    }
    default:
      return state;
  }
};

export default combineReducers({ subscription, card, billingInformation });
